import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import IconButton from '@glass/web/components/base/IconButton';
import ListItem from '@glass/web/components/base/ListItem';
import ListItemIcon from '@glass/web/components/base/ListItemIcon';
import ListItemText from '@glass/web/components/base/ListItemText';
import FavoriteBorderRounded from '@glass/web/components/base/icons/FavoriteBorderRounded';
import FavoriteRounded from '@glass/web/components/base/icons/FavoriteRounded';

import toggleUserContentAction from '@glass/shared/modules/userContent/toggleUserContentAction';

const ContentListItem = React.memo(({ section, favorite, text, id, loading }) => {
  const dispatch = useDispatch();
  const handleContentToggle = useCallback(() => {
    if (!loading) {
      dispatch(toggleUserContentAction({ id, section, text }));
    }
  }, [dispatch, id, loading, section, text]);
  return (
    <ListItem disabled={loading}>
      <ListItemIcon>
        <IconButton
          color={favorite ? 'primary' : 'default'}
          edge="start"
          size="large"
          onClick={handleContentToggle}
        >
          {favorite ? <FavoriteRounded /> : <FavoriteBorderRounded />}
        </IconButton>
      </ListItemIcon>
      <ListItemText primary={text} />
    </ListItem>
  );
});

ContentListItem.propTypes = {
  favorite: PropTypes.bool,
  id: PropTypes.string,
  loading: PropTypes.bool,
  section: PropTypes.string,
  text: PropTypes.string,
};

export default React.memo(ContentListItem);
